import type { Difficulty } from '../settings/types.js';
import type { SearchLimits } from './AlphaBetaSearch.js';

export interface DifficultyProfile {
  readonly limits: SearchLimits;
  /**
   * Root-move noise in centipawns. Non-zero levels score every root move at
   * `limits.maxDepth` and pick the best after adding uniform noise of this
   * size — strength drops smoothly instead of the bot blundering at random.
   */
  readonly noiseCp: number;
  /** Accept a draw offer when the bot's static eval is at or below this. */
  readonly acceptDrawAtCp: number;
}

const PROFILES: Readonly<Record<Difficulty, DifficultyProfile>> = {
  easy: { limits: { maxDepth: 1, timeMs: 400, quiescenceDepth: 2 }, noiseCp: 180, acceptDrawAtCp: -50 },
  normal: { limits: { maxDepth: 2, timeMs: 700, quiescenceDepth: 4 }, noiseCp: 45, acceptDrawAtCp: -100 },
  hard: { limits: { maxDepth: 4, timeMs: 1_200, quiescenceDepth: 6 }, noiseCp: 0, acceptDrawAtCp: -150 },
  expert: { limits: { maxDepth: 8, timeMs: 2_500, quiescenceDepth: 8 }, noiseCp: 0, acceptDrawAtCp: -200 },
};

export function profileFor(difficulty: Difficulty): DifficultyProfile {
  return PROFILES[difficulty];
}
